<script>
    import VueContentLoading from 'vue-content-loading';

    export default {
        components: {
            VueContentLoading,
        },
    };
</script>

<template>
    <vue-content-loading :width="300" :height="110">
        <rect x="2" y="2" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="2" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="2" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="2" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="2" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="12" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="12" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="12" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="12" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="12" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="22" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="22" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="22" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="22" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="22" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="32" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="32" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="32" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="32" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="32" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="42" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="42" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="42" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="42" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="42" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="52" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="52" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="52" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="52" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="52" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="62" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="62" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="62" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="62" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="62" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="72" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="72" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="72" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="72" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="72" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="82" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="82" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="82" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="82" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="82" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="92" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="92" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="92" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="92" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="92" rx="1" ry="1" width="20" height="4" />

        <rect x="2" y="102" rx="1" ry="1" width="45" height="4" />
        <rect x="55" y="102" rx="1" ry="1" width="80" height="4" />
        <rect x="145" y="102" rx="1" ry="1" width="30" height="4" />
        <rect x="185" y="102" rx="1" ry="1" width="75" height="4" />
        <rect x="270" y="102" rx="1" ry="1" width="20" height="4" />

    </vue-content-loading>
</template>
